import React, { useContext } from "react";
import ImageContainer from "@components/imageContainer";
import { Flex } from "@acko-tech/building-blocks.ui.common";
import { getWidgetSpecificIsVisible } from "@utils/index";
import { Context } from "@components/useContext/context";
import { HeaderWrapper } from "./styles";
import { store } from "@store/store";
import { connect } from "react-redux";
import { useRouter } from "next/router";

// import Back from "@public/images/back-icon.svg";
import { resolvePath } from "@utils/resolvePath";
import { useOnload } from "@utils/useOnLoad";
import { useWebviewCallback } from "@utils/useWebviewCallback";
import { EWebViewActions } from "@utils/types";
import { ACKO_LOGO_URL } from "@utils/constants";

const mapStateToProps = function (state: any, ownProps: any) {
  return {
    is_visible: getWidgetSpecificIsVisible(
      state.configuration?.normalisedConfig,
      ownProps.id
    )
  };
};

const Header = (props: any) => {
  const { isDesktop } = useContext(Context);
  const router = useRouter();
  const { is_visible, mStyles, children, actions, styles } = props;

  const { on_load, on_back_click } = actions || {};

  useOnload({ on_load });

  const customBack = () => router.back();

  const goBack = () => {
    const layoutIds = on_back_click?.map((func: any) => func.args.layoutIds);
    const layoutIdsArray = layoutIds[0];
    const firstLayoutId = layoutIdsArray[0];
    const state = store?.getState();
    const normalisedConfig = state?.configuration?.normalisedConfig;
    const firstLayoutVisible =
      normalisedConfig[firstLayoutId]?.props?.is_visible === true;
    if (firstLayoutVisible) {
      try {
        useWebviewCallback(
          {
            action: EWebViewActions.CAN_USE_NATIVE_BACK_PRESS,
            action_value: {}
          },
          customBack,
          (res: any) => {
            if (res === true) {
              useWebviewCallback(
                {
                  action: EWebViewActions.NATIVE_BACK_PRESS,
                  action_value: {}
                },
                customBack
              );
            } else {
              customBack();
            }
          }
        );
      } catch (e) {
        console.log("Catch", e);
        router.back();
      }
      return;
    } else {
      on_back_click?.forEach(
        (eachFunc) =>
          typeof eachFunc.funCall === "function" &&
          eachFunc.funCall(eachFunc.args)
      );
    }
  };

  return is_visible ? (
    <HeaderWrapper
      style={{ borderColor: "rgb(230, 234, 240)", ...styles }}
      mStyles={mStyles}
    >
      <Flex
        justifyContent="space-between"
        alignItems="center"
        style={{
          maxWidth: "1170px",
          margin: "auto",
          height: "56px",
          marginBottom: "4px",
          ...styles
        }}
      >
        {isDesktop ? (
          <a href={process.env.HOST_URL}>
            <img
              src={ACKO_LOGO_URL}
              alt="url"
              style={{ height: "28px", width: "auto" }}
            />
          </a>
        ) : (
          <div
            onClick={() => goBack()}
            style={{ cursor: "pointer", marginLeft: "8px" }}
          >
            <ImageContainer
              imgSrc={resolvePath("/images/back-icon.svg")}
              alt="url"
              width={32}
              height={28}
            />
          </div>
        )}
      </Flex>
      {children}
    </HeaderWrapper>
  ) : (
    <></>
  );
};

export default connect(mapStateToProps)(Header);
